import React from "react";
import {Row, Col} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner, GDMap, ImageAuto } from "@reco-w/core-ui";
import { Namespaces, aboutusModel } from "@reco-w/aboutus-models";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination, Thumbs, EffectFade } from "swiper";
import { BackTopBox } from "@reco-w/about-e";
SwiperCore.use([Autoplay, Navigation, Pagination, Thumbs, EffectFade]);

export namespace AboutUs {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState, aboutusModel.StateType {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.aboutus;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/aboutus`);
        }
        componentDidMount() {
            this.dispatch("input", { honorIndex: 5, courseDirection: "horizontal", courseEnabled: true});
            this.scalePage();
            $(window).resize(() => {
                return this.scalePage();
            });
        }
        scalePage() {
            const width = document.documentElement.clientWidth;
            if (width < 770) {
                this.dispatch("input", { honorIndex: 2, courseDirection: "vertical", courseEnabled: false});
            } else {
                this.dispatch("input", { honorIndex: 5, courseDirection: "horizontal", courseEnabled: true });
            }
        }


        renderResource() {
            return (
                <div className="block-content company-content">
                    <div className="container">
                        <div className="second-title">
                            <span>了解我们</span>
                        </div>
                        <div className="company-info">
                            <p>上海新瑞谷科技集团有限公司（简称瑞谷集团）成立于2011年，是国内领先的产业园区科技服务商，始终坚持以科技创新赋能园区产业发展，满足园区不断升级的需求。围绕园区数字化、产业创新、产业招商三大方向，为产业园区提供一站式招商运营服务，为政府和企业提供智慧精准解决方案，成为政府和企业产业服务全方位合作伙伴。</p>
                            <p>瑞谷集团拥有300人团队，与阿里云、蚂蚁链、华为云、宝马初创车库等十数家国内外龙头企业，以及全国30多个城市的500多家政府园区开展长期合作。</p>
                        </div>
                    </div>
                </div>
            )
        }

        renderSystem() {
            const {state} = this.props,
                courseDirection = state!.courseDirection,
                courseEnabled = state!.courseEnabled;
            return (
                <div className="block-content course-content">
                    <div className="second-title">
                        <span>瑞谷历程</span>
                    </div>
                    {(courseEnabled === true || courseEnabled === false) &&
                        <Swiper
                            style={{ height: 475 }}
                            className="course-swiper mt50"
                            direction={courseDirection}
                            slidesPerView={"auto"}
                            // freeMode={true}
                            // scrollbar={{ draggable: true }}
                            enabled={courseEnabled}
                        >
                            <SwiperSlide>
                                <div className="course-item">
                                    <div className="course-item-write">
                                        <p>
                                            瑞谷拜特（上海）正式成立<br />
                                            推出软件产品Bipark V1.0
                                        </p>
                                    </div>
                                    <div className="course-item-dot" />
                                    <div className="course-item-date">2011</div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide">
                                <div className="course-item">
                                    <div className="course-item-write">
                                        <p>
                                            设立瑞谷拜特北京总部
                                            <br />
                                            客户突破100+
                                        </p>
                                        <p><img src="assets/images/course-logo1.png" height="40px" /></p>
                                    </div>
                                    <div className="course-item-dot" />
                                    <div className="course-item-date">2014</div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide">
                                <div className="course-item">
                                    <div className="course-item-write">
                                        <p>
                                            与阿里云达成战略合作
                                            <br />成立科创运营品牌RECO SPACE
                                        </p>
                                        <p><img src="assets/images/course-logo2.png" height="44px" /></p>
                                    </div>
                                    <div className="course-item-dot" />
                                    <div className="course-item-date">2015</div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide">
                                <div className="course-item">
                                    <div className="course-item-write">
                                        <p>
                                            组建瑞谷云企团队
                                            <br />布局企业服务业务
                                        </p>
                                        <p><img src="assets/images/course-logo3.png" height="50px" /></p>
                                    </div>
                                    <div className="course-item-dot" />
                                    <div className="course-item-date">2020</div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide">
                                <div className="course-item">
                                    <div className="course-item-write">
                                        <p>
                                            与宝马初创车库和蚂蚁链达成战略合作，
                                            <br />打造智能汽车和区块链创新基地
                                        </p>
                                        <p><img src="assets/images/course-logo4.png" height="44px" /></p>
                                    </div>
                                    <div className="course-item-dot" />
                                    <div className="course-item-date">2021</div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide">
                                <div className="course-item">
                                    <div className="course-item-write">
                                        <p>
                                            品牌正式升级为瑞谷集团
                                            <br />全面进入蓬勃发展新阶段
                                        </p>
                                    </div>
                                    <div className="course-item-dot" />
                                    <div className="course-item-date">2023</div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    }
                </div>
            )
        }

        renderService() {
            const honorData = [
                "assets/images/certificate/1.png",
                "assets/images/certificate/2.png",
                "assets/images/certificate/3.png",
                "assets/images/certificate/4.png",
                "assets/images/certificate/5.png",
                "assets/images/certificate/6.png",
                "assets/images/certificate/7.png",
                "assets/images/certificate/8.png",
                "assets/images/certificate/9.png",
                "assets/images/certificate/10.png",
                "assets/images/certificate/11.png",
                "assets/images/certificate/12.png",
            ]
            const {state} = this.props,
                honorIndex = state!.honorIndex;
            return (
                <div className="block-content honor-content">
                    <div className="container">
                        <div className="second-title">
                            <span>瑞谷荣誉</span>
                        </div>
                        <Swiper
                            style={{ height: 360 }}
                            className="honor-swiper mt70"
                            loop={honorIndex===2 || honorIndex ===5}
                            slidesPerView={honorIndex}
                            pagination={true}
                            spaceBetween={10}
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,  //false: 鼠标操作屏幕后继续自动滚屏
                            }}
                        >
                            {
                                honorData.map((item, i) => {
                                    return (
                                        <SwiperSlide key={i}>
                                            <div className="honor-item">
                                                <ImageAuto.Component src={item} width="100%" height="100%" radius={0} />
                                            </div>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                    </div>
                </div>
            )
        }



        renderContact() {
            return (
                <div className="block-content contact-content">
                    <div className="container">
                        <div className="second-title">
                            <span>联系方式</span>
                        </div>
                        <Row className="contact-row">
                            <Col xs={12} sm={12} md={12} xl={6}>
                                <div className="contact-item">
                                    <div className="contact-item-icon">
                                        <img src="assets/images/contact-icon1.png" />
                                    </div>
                                    <div className="size-18 primary-color">Tel</div>
                                    <div className="size-24 mt20">400-026-9898</div>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={12} xl={6}>
                                <div className="contact-item">
                                    <div className="contact-item-icon">
                                        <img src="assets/images/contact-icon2.png" />
                                    </div>
                                    <div className="size-18 primary-color">Fax</div>
                                    <div className="size-24 mt20">021-20231081</div>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={12} xl={6}>
                                <div className="contact-item">
                                    <div className="contact-item-icon">
                                        <img src="assets/images/contact-icon3.png" />
                                    </div>
                                    <div className="size-18 primary-color">E-Mail</div>
                                    <div className="size-24 mt20">service@bitech.cn</div>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={12} xl={6}>
                                <div className="contact-item">
                                    <div className="contact-item-icon">
                                        <img src="assets/images/contact-icon4.png" />
                                    </div>
                                    <div className="size-18 primary-color">Address</div>
                                    <div className="size-18 mt20">浦东·张江秋月路26号<br />张江矽岸国际7号楼</div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="map-box">
                        <GDMap.Component address={"上海市浦东新区秋月路26号矽岸国际7号楼"} mapStyle={""} />
                    </div>
                </div>
            )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/guanw/gyjt-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1">关于瑞谷</div>
                                <div className="banner-text-name2 mt25">
                                    产业园区科技服务商
                                </div>
                            </div>}
                        />
                        {this.renderResource()}
                        {this.renderSystem()}
                        {this.renderService()}
                        {this.renderContact()}


                        {this.renderEmbeddedView(BackTopBox.Page)}
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.aboutus]);
}
